// extracted by mini-css-extract-plugin
module.exports = {"normalMax":"Index_normalMax__1IAUD","normal":"Index_normal__2-dsV","normalH5":"Index_normalH5__3XblX","animationFade":"Index_animationFade__2pq8o"};